(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["history-slider"] && !Shopify.designMode) return;
  try {
    
    $(document).ready(function () {
        var target = $(".timeline-img, .timeline-text__item");
        if (window.matchMedia("(max-width: 600px)").matches) {
          function scroll_show() {
              var windowHeight = $(window).height();
              var windowTop = $(window).scrollTop();
              var visible = 0;
  
              target.each(function () {
                  var item = $(this);
                  var itemTop = item.offset().top;
                  var itemBottom = itemTop + item.height();
  
                  if (itemTop < windowTop + windowHeight && itemBottom > windowTop) {
                      if (!item.hasClass("show")) {
                          if (item.hasClass("timeline-img")) {
                              setTimeout(function () {
                                  item.addClass("show");
                              }, visible * 300);
                          } else if (item.hasClass("timeline-text__item")) {
                              setTimeout(function () {
                                  item.addClass("show");
                              }, (visible + 1) * 100);
                          }
                          visible++;
                      }
                  }
              });
          }
          $(window).on("scroll", function () {
              scroll_show();
          });
          scroll_show();
        }

        $(".timeline-svg").on("click", function () {
            var btnId = $(this).attr("id").replace("timeline-svg", "");
            var $container = $("#container");
            var $target = $("#timeline-img" + btnId);
            var container = $container[0];
            var target = $target[0];
            var targetCenter = target.offsetLeft + (target.offsetWidth / 2);
            var containerCenter = container.clientWidth / 2;
            var scrollTo = targetCenter - containerCenter;
        
            if (Math.abs(container.scrollLeft - scrollTo) > 1) {
                $container.animate({
                    scrollLeft: scrollTo
                }, 800);
            }
        });

        // SP表示用トリミング
        var window_wd = $(window).width();
        if(window_wd <= 600){
            $(".timeline-img").each(function(index){
                var sp_img_height = $(".timeline-img__item").height();
                console.log(sp_img_height);
                var margin = (sp_img_height / 5) - 10;
              console.log('img: '+margin);
                if(index != 0) {
                $(this).css("margin-top", "-" + margin +"px");
                }
            })
            $(".timeline-text div").each(function(index){
              var sp_text_height = $(".timeline-img__item").height();
              var margin = (sp_text_height / 5) - 10;
              console.log('text: '+margin);
              if(index !== 0) {
                $(this).css("margin-top", "-" + margin + "px");
              }
            });
            $(".timeline-img__item").each(function(index){
                var sp_img_width = $(this).width();
                var sp_img_height = $(this).height();
                // width
                var wd_center = sp_img_width / 2;
                var wd_max = sp_img_width;
                // height
                var ht_top = 0;
                var ht_allow = sp_img_height / 5;
                var ht_allow2 = sp_img_height - ht_allow;
                var ht_max = sp_img_height;
                let zahyou;
                if(index == 0) {
                    zahyou = `polygon(
                        0px 0px,
                        ${wd_max}px 0px,
                        ${wd_max}px ${ht_allow2}px,
                        ${wd_center}px ${ht_max}px,
                        0px ${ht_allow2}px
                    )`;
                } else {
                    zahyou = `polygon(
                        0px 0px,
                        ${wd_center}px ${ht_allow}px,
                        ${wd_max}px 0,
                        ${wd_max}px ${ht_allow2}px,
                        ${wd_center}px ${ht_max}px,
                        0 ${ht_allow2}px
                    )`;
                }
                $(this).css("clip-path", zahyou);
                $(this).css("background-position", "center");
            })
        }
    });
    $(function () {
      $(".timeline-btn svg polygon").on("mouseenter", function () {
        $(this).closest("svg").find("text").css("fill", "#fff");
      });
      $(".timeline-btn svg polygon").on("mouseleave", function () {
        $(this).closest("svg").find("text").css("fill", "#818181");
      });
    });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sponsored-athlete"]) return;
  try {
    
  let headerVisible = false;
  function scroll_responsive() {
    if ($(window).width() >= 990) {
      if ($(window).scrollTop() > 0) {
        if (!headerVisible) {
          headerVisible = true;

          $('.drawer_open').css('display', 'flex');
          $('.drawer_open').css('margin-left', '0');
          $('.drawer_open span').addClass('scroll');
          $('.focus-inset img').addClass('scroll');
          $('.nav_content').addClass('scroll');
          $('.nav_content_drawer').addClass('scroll');
          $('.nav_content_warp').addClass('scroll');

          setTimeout(function () {
            $('.header-sns')
              .stop(true, true)
              .hide()
              .css({ opacity: 0, display: 'flex' })
              .show()
              .animate({ opacity: 1 }, 300);

            $('.header-sns img')
              .css({ display: 'flex', opacity: 0 })
              .stop(true, true)
              .animate({ opacity: 1 }, 300);

            $('.header-sns-wrap_margin')
              .css({ display: 'flex', 'justify-content': 'end', opacity: 0 })
              .stop(true, true)
              .animate({ opacity: 1 }, 300);

            $('.header__inline-menu').stop(true, true).fadeOut(200, function() {
              $(this).css('display', 'none');
            });
            $('svg.header-logo_pc').stop(true, true).fadeOut(200, function() {
              $(this).css('display', 'none');
            });
          }, 50);
        }
      } else {
        if (headerVisible) {
          headerVisible = false;
          
          $('.nav_content').removeClass('scroll');
          $('.nav_content_drawer').removeClass('scroll');
          $('.nav_content_warp').removeClass('scroll');
          $('.focus-inset img').removeClass('scroll');

          setTimeout(function () {
          $('.drawer_open').css('display', 'none');
          $('.drawer_open').css('margin-left', '20px');
          $('.drawer_open span').removeClass('scroll');
          $('.header-sns').stop(true, true).fadeOut(200, function() {
            $(this).css('display', 'none');
          });
          $('.header-sns img').stop(true, true).fadeOut(200, function() {
            $(this).css('display', 'none');
          });
          $('.header__inline-menu').stop(true, true).fadeIn(300, function() {
            $(this).css('display', 'flex');
          });
          $('svg.header-logo_pc').stop(true, true).fadeIn(300, function() {
            $(this).css('display', 'block');
          });
          $('.header-sns-wrap_margin').stop(true, true).fadeIn(300, function() {
            $(this).css('display', 'block');
          });
          }, 50);
        }
      }
    } else {
      $('.nav_content').addClass('.scroll');
    }
  };
  $(window).on("scroll", function() {
    scroll_responsive();
  });
  scroll_responsive();

  } catch(e) { console.error(e); }
})();
})();
